import i18n from "src/i18n";
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'outbreak',
      label: i18n.t('diseases.outbreaks_number'),
      minWidth: 150,
    },
    {
      prop: 'cases',
      label: i18n.t('diseases.cases_quantity'),
      minWidth: 150,
    },
    {
      prop: 'area_m2',
      label: `${i18n.t('common_words.area')} (m2)`,
      minWidth: 150,
    },
    {
      prop: 'area_hectares',
      label: `${i18n.t('common_words.area')} (Ha)`,
      minWidth: 150,
    },
    {
      prop: 'latitude',
      label: i18n.t('common_words.latitude'),
      minWidth: 170,
    },
    {
      prop: 'longitude',
      label: i18n.t('common_words.longitude'),
      minWidth: 170,
    },
    {
      prop: 'altitude',
      label: i18n.t('common_words.altitud_msmn'),
      minWidth: 170,
    },
  ];

  return { Table };
};

export default configTable;
